"use strict";

var _regeneratorRuntime = require("/Users/nathanmartin/Developer/projects/blockstack/a-dark-screen/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var queryString = require("query-string"); // @ts-ignore: Could not find a declaration file for module


var jsontokens_1 = require("jsontokens");

var authVerification_1 = require("./authVerification");

var utils_1 = require("../utils");

var fetchUtil_1 = require("../fetchUtil");

var dids_1 = require("../dids");

var errors_1 = require("../errors");

var authMessages_1 = require("./authMessages");

var authConstants_1 = require("./authConstants");

var profileTokens_1 = require("../profiles/profileTokens");

var userSession_1 = require("./userSession");

var config_1 = require("../config");

var logger_1 = require("../logger");

var protocolEchoDetection_1 = require("./protocolEchoDetection");

var protocolLaunch_1 = require("./protocolLaunch");

var DEFAULT_PROFILE = {
  '@type': 'Person',
  '@context': 'http://schema.org'
};
/**
 * @deprecated
 * #### v19 Use [[UserSession.isUserSignedIn]] instead.
 *
 * Check if a user is currently signed in.
 * @return {Boolean} `true` if the user is signed in, `false` if not.
 */

function isUserSignedIn() {
  console.warn('DEPRECATION WARNING: The static isUserSignedIn() function will be deprecated in ' + 'the next major release of blockstack.js. Create an instance of UserSession and call the ' + 'instance method isUserSignedIn().');
  var userSession = new userSession_1.UserSession();
  return userSession.isUserSignedIn();
}

exports.isUserSignedIn = isUserSignedIn;
/**
 *
 *
 * @deprecated
 * #### v19 Use [[UserSession.isUserSignedIn]] instead.
 *
 * Generates an authentication request and redirects the user to the Blockstack
 * browser to approve the sign in request.
 *
 * Please note that this requires that the web browser properly handles the
 * `blockstack:` URL protocol handler.
 *
 * Most applications should use this
 * method for sign in unless they require more fine grained control over how the
 * authentication request is generated. If your app falls into this category,
 * use `makeAuthRequest` and `redirectToSignInWithAuthRequest` to build your own sign in process.
 *
 * @param {String} [redirectURI=`${window.location.origin}/`]
 * The location to which the identity provider will redirect the user after
 * the user approves sign in.
 * @param  {String} [manifestURI=`${window.location.origin}/manifest.json`]
 * Location of the manifest file.
 * @param  {Array} [scopes=DEFAULT_SCOPE] Defaults to requesting write access to
 * this app's data store.
 * An array of strings indicating which permissions this app is requesting.
 * @return {void}
 */

function redirectToSignIn(redirectURI, manifestURI, scopes) {
  console.warn('DEPRECATION WARNING: The static redirectToSignIn() function will be deprecated in the ' + 'next major release of blockstack.js. Create an instance of UserSession and call the ' + 'instance method redirectToSignIn().');
  var authRequest = authMessages_1.makeAuthRequest(null, redirectURI, manifestURI, scopes);
  redirectToSignInWithAuthRequest(authRequest);
}

exports.redirectToSignIn = redirectToSignIn;
/**
 * @deprecated
 * #### v19 Use [[UserSession.isSignInPending]] instead.
 *
 * Check if there is a authentication request that hasn't been handled.
 *
 * Also checks for a protocol echo reply (which if detected then the page
 * will be automatically redirected after this call).
 *
 * @return {Boolean} `true` if there is a pending sign in, otherwise `false`
 */

function isSignInPending() {
  try {
    var isProtocolEcho = protocolEchoDetection_1.protocolEchoReplyDetection();

    if (isProtocolEcho) {
      logger_1.Logger.info('protocolEchoReply detected from isSignInPending call, the page is about to redirect.');
      return true;
    }
  } catch (error) {
    logger_1.Logger.error("Error checking for protocol echo reply isSignInPending: ".concat(error));
  }

  return !!getAuthResponseToken();
}

exports.isSignInPending = isSignInPending;
/**
 * @deprecated
 * #### v19 Use [[UserSession.getAuthResponseToken]] instead.
 *
 * Retrieve the authentication token from the URL query
 * @return {String} the authentication token if it exists otherwise `null`
 */

function getAuthResponseToken() {
  var search = utils_1.getGlobalObject('location', {
    throwIfUnavailable: true,
    usageDesc: 'getAuthResponseToken'
  }).search;
  var queryDict = queryString.parse(search);
  return queryDict.authResponse ? queryDict.authResponse : '';
}

exports.getAuthResponseToken = getAuthResponseToken;
/**
 * @deprecated
 * #### v19 Use [[UserSession.loadUserData]] instead.
 *
 * Retrieves the user data object. The user's profile is stored in the key `profile`.
 * @return {Object} User data object.
*/

function loadUserData() {
  console.warn('DEPRECATION WARNING: The static loadUserData() function will be deprecated in the ' + 'next major release of blockstack.js. Create an instance of UserSession and call the ' + 'instance method loadUserData().');
  var userSession = new userSession_1.UserSession();
  return userSession.loadUserData();
}

exports.loadUserData = loadUserData;
/**
 * @deprecated
 * #### v19 Use [[UserSession.signUserOut]] instead.
 *
 * Sign the user out and optionally redirect to given location.
 * @param  redirectURL
 * Location to redirect user to after sign out.
 * Only used in environments with `window` available
 */

function signUserOut(redirectURL, caller) {
  var userSession = caller || new userSession_1.UserSession();
  userSession.store.deleteSessionData();

  if (redirectURL) {
    utils_1.getGlobalObject('location', {
      throwIfUnavailable: true,
      usageDesc: 'signUserOut'
    }).href = redirectURL;
  }
}

exports.signUserOut = signUserOut;
/**
 * @deprecated
 * #### v19 Use [[UserSession.redirectToSignInWithAuthRequest]] instead.
 *
 * Redirects the user to the Blockstack browser to approve the sign in request
 * given.
 *
 * The user is redirected to the `blockstackIDHost` if the `blockstack:`
 * protocol handler is not detected. Please note that the protocol handler detection
 * does not work on all browsers.
 * @param  {String} authRequest - the authentication request generated by `makeAuthRequest`
 * @param  {String} blockstackIDHost - the URL to redirect the user to if the blockstack
 *                                     protocol handler is not detected
 * @return {void}
 */

function redirectToSignInWithAuthRequest(authRequest) {
  var blockstackIDHost = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : authConstants_1.DEFAULT_BLOCKSTACK_HOST;
  authRequest = authRequest || authMessages_1.makeAuthRequest();
  var httpsURI = "".concat(blockstackIDHost, "?authRequest=").concat(authRequest);

  var _utils_1$getGlobalObj = utils_1.getGlobalObjects(['navigator', 'location'], {
    throwIfUnavailable: true,
    usageDesc: 'redirectToSignInWithAuthRequest'
  }),
      navigator = _utils_1$getGlobalObj.navigator,
      location = _utils_1$getGlobalObj.location; // If they're on a mobile OS, always redirect them to HTTPS site


  if (/Android|webOS|iPhone|iPad|iPod|Opera Mini/i.test(navigator.userAgent)) {
    logger_1.Logger.info('detected mobile OS, sending to https');
    location.href = httpsURI;
    return;
  }

  function successCallback() {
    logger_1.Logger.info('protocol handler detected'); // The detection function should open the link for us
  }

  function failCallback() {
    logger_1.Logger.warn('protocol handler not detected');
    location.href = httpsURI;
  }

  protocolLaunch_1.launchCustomProtocol(authRequest, successCallback, failCallback);
}

exports.redirectToSignInWithAuthRequest = redirectToSignInWithAuthRequest;
/**
 * @deprecated
 * #### v19 Use [[UserSession.handlePendingSignIn]] instead.
 *
 * Try to process any pending sign in request by returning a `Promise` that resolves
 * to the user data object if the sign in succeeds.
 *
 * @param {String} nameLookupURL - the endpoint against which to verify public
 * keys match claimed username
 * @param {String} authResponseToken - the signed authentication response token
 * @param {String} transitKey - the transit private key that corresponds to the transit public key
 * that was provided in the authentication request
 * @return {Promise} that resolves to the user data object if successful and rejects
 * if handling the sign in request fails or there was no pending sign in request.
 */

function handlePendingSignIn() {
  var nameLookupURL = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var authResponseToken = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getAuthResponseToken();
  var transitKey = arguments.length > 2 ? arguments[2] : undefined;
  var caller = arguments.length > 3 ? arguments[3] : undefined;
  return __awaiter(this, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var isProtocolEcho, msg, sessionData, _tokenPayload, isValid, tokenPayload, appPrivateKey, coreSessionToken, hubUrl, gaiaAssociationToken, userData, profileURL, response, responseText, wrappedProfile, profile;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            isProtocolEcho = protocolEchoDetection_1.protocolEchoReplyDetection();

            if (!isProtocolEcho) {
              _context.next = 6;
              break;
            }

            msg = 'handlePendingSignIn called while protocolEchoReply was detected, and ' + 'the page is about to redirect. This function will resolve with an error after ' + 'several seconds, if the page was not redirected for some reason.';
            logger_1.Logger.info(msg);
            return _context.abrupt("return", new Promise(function (_resolve, reject) {
              setTimeout(function () {
                logger_1.Logger.error('Page should have redirected by now. handlePendingSignIn will now throw.');
                reject(msg);
              }, 3000);
            }));

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            logger_1.Logger.error("Error checking for protocol echo reply handlePendingSignIn: ".concat(_context.t0));

          case 11:
            if (!caller) {
              caller = new userSession_1.UserSession();
            }

            sessionData = caller.store.getSessionData();

            if (!sessionData.userData) {
              _context.next = 15;
              break;
            }

            throw new errors_1.LoginFailedError('Existing user session found.');

          case 15:
            if (!transitKey) {
              transitKey = caller.store.getSessionData().transitKey;
            }

            if (nameLookupURL) {
              _context.next = 22;
              break;
            }

            _tokenPayload = jsontokens_1.decodeToken(authResponseToken).payload;

            if (!(typeof _tokenPayload === 'string')) {
              _context.next = 20;
              break;
            }

            throw new Error('Unexpected token payload type of string');

          case 20:
            if (utils_1.isLaterVersion(_tokenPayload.version, '1.3.0') && _tokenPayload.blockstackAPIUrl !== null && _tokenPayload.blockstackAPIUrl !== undefined) {
              // override globally
              logger_1.Logger.info("Overriding ".concat(config_1.config.network.blockstackAPIUrl, " ") + "with ".concat(_tokenPayload.blockstackAPIUrl));
              config_1.config.network.blockstackAPIUrl = _tokenPayload.blockstackAPIUrl;
            }

            nameLookupURL = "".concat(config_1.config.network.blockstackAPIUrl).concat(authConstants_1.NAME_LOOKUP_PATH);

          case 22:
            _context.next = 24;
            return authVerification_1.verifyAuthResponse(authResponseToken, nameLookupURL);

          case 24:
            isValid = _context.sent;

            if (isValid) {
              _context.next = 27;
              break;
            }

            throw new errors_1.LoginFailedError('Invalid authentication response.');

          case 27:
            tokenPayload = jsontokens_1.decodeToken(authResponseToken).payload;

            if (!(typeof tokenPayload === 'string')) {
              _context.next = 30;
              break;
            }

            throw new Error('Unexpected token payload type of string');

          case 30:
            // TODO: real version handling
            appPrivateKey = tokenPayload.private_key;
            coreSessionToken = tokenPayload.core_token;

            if (!utils_1.isLaterVersion(tokenPayload.version, '1.1.0')) {
              _context.next = 53;
              break;
            }

            if (!(transitKey !== undefined && transitKey != null)) {
              _context.next = 52;
              break;
            }

            if (!(tokenPayload.private_key !== undefined && tokenPayload.private_key !== null)) {
              _context.next = 49;
              break;
            }

            _context.prev = 35;
            appPrivateKey = authMessages_1.decryptPrivateKey(transitKey, tokenPayload.private_key);
            _context.next = 49;
            break;

          case 39:
            _context.prev = 39;
            _context.t1 = _context["catch"](35);
            logger_1.Logger.warn('Failed decryption of appPrivateKey, will try to use as given');
            _context.prev = 42;
            utils_1.hexStringToECPair(tokenPayload.private_key);
            _context.next = 49;
            break;

          case 46:
            _context.prev = 46;
            _context.t2 = _context["catch"](42);
            throw new errors_1.LoginFailedError('Failed decrypting appPrivateKey. Usually means' + ' that the transit key has changed during login.');

          case 49:
            if (coreSessionToken !== undefined && coreSessionToken !== null) {
              try {
                coreSessionToken = authMessages_1.decryptPrivateKey(transitKey, coreSessionToken);
              } catch (e) {
                logger_1.Logger.info('Failed decryption of coreSessionToken, will try to use as given');
              }
            }

            _context.next = 53;
            break;

          case 52:
            throw new errors_1.LoginFailedError('Authenticating with protocol > 1.1.0 requires transit' + ' key, and none found.');

          case 53:
            hubUrl = authConstants_1.BLOCKSTACK_DEFAULT_GAIA_HUB_URL;

            if (utils_1.isLaterVersion(tokenPayload.version, '1.2.0') && tokenPayload.hubUrl !== null && tokenPayload.hubUrl !== undefined) {
              hubUrl = tokenPayload.hubUrl;
            }

            if (utils_1.isLaterVersion(tokenPayload.version, '1.3.0') && tokenPayload.associationToken !== null && tokenPayload.associationToken !== undefined) {
              gaiaAssociationToken = tokenPayload.associationToken;
            }

            userData = {
              username: tokenPayload.username,
              profile: tokenPayload.profile,
              email: tokenPayload.email,
              decentralizedID: tokenPayload.iss,
              identityAddress: dids_1.getAddressFromDID(tokenPayload.iss),
              appPrivateKey: appPrivateKey,
              coreSessionToken: coreSessionToken,
              authResponseToken: authResponseToken,
              hubUrl: hubUrl,
              gaiaAssociationToken: gaiaAssociationToken
            };
            profileURL = tokenPayload.profile_url;

            if (!(!userData.profile && profileURL)) {
              _context.next = 74;
              break;
            }

            _context.next = 61;
            return fetchUtil_1.fetchPrivate(profileURL);

          case 61:
            response = _context.sent;

            if (response.ok) {
              _context.next = 66;
              break;
            }

            // return blank profile if we fail to fetch
            userData.profile = Object.assign({}, DEFAULT_PROFILE);
            _context.next = 72;
            break;

          case 66:
            _context.next = 68;
            return response.text();

          case 68:
            responseText = _context.sent;
            wrappedProfile = JSON.parse(responseText);
            profile = profileTokens_1.extractProfile(wrappedProfile[0].token);
            userData.profile = profile;

          case 72:
            _context.next = 75;
            break;

          case 74:
            userData.profile = tokenPayload.profile;

          case 75:
            sessionData.userData = userData;
            caller.store.setSessionData(sessionData);
            return _context.abrupt("return", userData);

          case 78:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8], [35, 39], [42, 46]]);
  }));
}

exports.handlePendingSignIn = handlePendingSignIn;